import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import './styles.scss'

const ToggleBlock = ({ className, color, onClick }: IBlockProps): ReactElement => {
  const classes = classNames('block toggle-block', className)

  return (
    <div className={classes}>
      <div className="toggle-component" onClick={onClick} style={{ backgroundColor: color }}>
        <div className="toggle-thumb" />
      </div>
    </div>
  )
}

export default ToggleBlock
